import React from 'react'

import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import Colors from 'utils/Colors'
import DashboardCard from '../Statistics/DashboardCard'

ChartJS.register(ArcElement, Tooltip, Legend)

const DoughnutChart = (props) => {
  const { data, labels, title, colors } = props

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      datalabels: {
        display: false,
      },
    },
    layout: {
      padding: {
        left: 40,
        right: 40,
        top: '6rem',
      },
    },
  }

  const graphData = {
    labels: labels,
    datasets: [
      {
        label: 'Aplicações',
        data: data,
        backgroundColor: colors,
        borderColor: Colors.white,
        borderWidth: 1,
        hoverOffset: 8,
      },
    ],
  }

  return (
    <DashboardCard
      title={title}
    >
      <Doughnut data={graphData} options={options} />
    </DashboardCard>
  )
}


export default DoughnutChart
